import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

const SidebarContent = props => {
  const ref = useRef();
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname;
    
    const initMenu = () => {
      new MetisMenu("#side-menu");
      let matchingMenuItem = null;
      const ul = document.getElementById("side-menu");
      const items = ul.getElementsByTagName("a");
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    initMenu();
  }, [props.location.pathname]);

  useEffect(() => {
    ref.current.recalculate();
  });

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>

            <li> <Link className="nav-link arrow-none" to={`/dashboard`}> <i className="bx bx-home-circle"></i> <span>{props.t("Dashboard")}</span></Link> </li>

            <li> <Link to="/property"> <i className="bx bx-building-house"></i> <span>{props.t("Properties")}</span> </Link> </li>

            <li>
              <Link to="/#" className="has-arrow"> <i className="bx bx-user-circle"></i> <span>{props.t("User Management")}</span> </Link>
              <ul className="sub-menu">
                <li> <Link to="/user_management">{props.t("All Users")}</Link> </li>
                <li> <Link to="/pending_registration_user">{props.t("Pending Registration Users")}</Link> </li>
                <li> <Link to="/add_user">{props.t("Add User")}</Link> </li>
                <li> <Link to="/add-euro-wallet">{props.t("Add EUR Wallet")}</Link> </li>
              </ul>
            </li>

            <li> <Link to="/collaborators"> <i className="fas fa-handshake"></i> <span>{props.t("Collaborators")}</span> </Link> </li>

            <li>
              <Link to="/#" className="has-arrow"> <i className="bx bx-user-circle"></i> <span>{props.t("Report")}</span> </Link>
              <ul className="sub-menu">
                <li> <Link to="/users_report">{props.t("Users")}</Link> </li>
                <li> <Link to="/transactions_report">{props.t("Transactions")}</Link> </li>
              </ul>
            </li>

            <li> <Link to="/claim_fund"> <i className="bx bx-money"></i> <span>{props.t("Claim Fund Requests")}</span> </Link> </li>

            <li> <Link to="/withdrawal_request"> <i className="bx bx-transfer-alt"></i> <span>{props.t("Withdrawal Requests")}</span> </Link> </li>
            <li> <Link to="/all_users_bonus"> <i className="bx bx-money"></i> <span>{props.t("Users Bonus")}</span> </Link> </li>

            <li> <Link to="/welcome_bonus"> <i className="bx bx-money"></i> <span>{props.t("Welcome Bonus")}</span> </Link> </li>
            <li> <Link to="/referral_reward"> <i className="bx bx-award"></i> <span>{props.t("Referral Reward")}</span> </Link> </li>

            <li>
              <Link to="/#" className="has-arrow"> <i className="bx bx-wallet-alt"></i> <span>{props.t("Dividends")}</span> </Link>
              <ul className="sub-menu">
                <li> <Link to="/dividends">{props.t("Record Dividend")}</Link> </li>
                <li> <Link to="/dividends_transactions">{props.t("Dividend Transactions")}</Link> </li>
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-list-ul"></i>
                <span>{props.t("Transactions")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/transaction">{props.t("All Transactions")}</Link>
                </li>
                <li>
                  <Link to="/add_transaction">{props.t("Add Transaction")}</Link>
                </li>
              </ul>
            </li>

            <li> <Link to="/user_kyc"> <i className="bx bxs-user-check"></i> <span>{props.t("Users KYC")}</span> </Link> </li>
            <li> <Link to="/gift_card"> <i className="bx bx-gift"></i> <span>{props.t("Gift Card")}</span> </Link> </li>

            <li>
              <Link to="/#" className="has-arrow"> <i className="bx bx-cog"></i> <span>{props.t("Settings")}</span> </Link>
              <ul className="sub-menu">
                <li> <Link to="/general_settings"> <span>{props.t("General Settings")}</span></Link> </li>
                <li> <Link to="/sem_settings">{props.t("SEMs Settings")}</Link> </li>
                <li> <Link to="/email_format">{props.t("Email Formats")}</Link> </li>
                <li> <Link to="/withdrawal_settings">{props.t("Withdrawal & Referral Setting")}</Link> </li>
                <li> <Link to="/bank-details">{props.t("Bank Details")}</Link> </li>
                <li> <Link to="/sync-mailchimp">{props.t("Mailchimp Data Sync")}</Link> </li>
              </ul>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
